<!-- <h2>Payment Request Button</h2> -->
@if (isButton) {
  <ngx-stripe-payment-request-button [paymentOptions]="paymentRequestOptions" (paymentMethod)="onPaymentMethod($event)" (shippingaddresschange)="onShippingAddressChange($event)" (notavailable)="onNotAvailable()"></ngx-stripe-payment-request-button>
}
